import { useEffect } from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import Animated, {
  AnimatedStyle,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import cn from '@ui/utils/cn'

interface Props {
  opacities?: [number, number] // [0.5, 1]
  className?: string
  style?: StyleProp<ViewStyle> | AnimatedStyle<ViewStyle>
}

const REPEAT = -1
const DURATION = 1000
const REVERSE = true

export default function Skeleton({ className, style, opacities }: Props) {
  const [opacityStart, opacityEnd] = opacities ?? [0.5, 1]

  const opacity = useSharedValue(opacityStart)
  const startAnimation = () => {
    opacity.set(
      withRepeat(
        withTiming(opacityEnd, { duration: DURATION }),
        REPEAT,
        REVERSE
      )
    )
  }

  const styleAnimation = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    }
  })

  useEffect(() => {
    startAnimation()
    return () => {
      cancelAnimation(opacity)
    }
  }, [])

  return (
    <Animated.View className={cn(className)} style={[styleAnimation, style]} />
  )
}
